import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import Sidebar from "components/Layout/Sidebar";
import Header from "components/Layout/Header";
import Footer from "components/Layout/Footer";
import styled from "styled-components";
import { Event, decode, encode, wait, isMobile, sendNotfication } from 'utils/Helper';
import WalletAlert from "components/User/Wallet/Alert";
import C from 'utils/Constant';
import storage from "utils/Storage";
import socket from "utils/Socket";

const SIDEBAR_WIDTH = 239;
const HEADER_HEIGHT = 60;

const AppContainer = styled.div`
  display: flex;
  background-color: #232626;
  color: white;
  font-family: Arial, sans-serif;
`;

const MainArea = styled.div`
  flex: 1;
  padding-top: 60px;
  min-height: 100vh;
  width: calc(100vw - ${SIDEBAR_WIDTH}px);
  overflow-x: hidden;
  z-index: -1 important;
  margin-left: ${(props) =>
    props.isSmallScreen ? "0px" : props.isCollapsed ? "86px" : "242px"};
  transition: margin-left 0.3s ease;

  @media (max-width: 576px) {
    padding-top: 0px;
  }
`;

const ContentContainer = styled.div`
  padding: 10px;
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
`;

const HeaderMainConatiner = styled.div`
  position: fixed;
  top: 0;
  left: ${(props) =>
    props.isSmallScreen ? "0px" : props.isCollapsed ? "0px" : "0px"};
  right: 0;
  z-index: 666;
  width: 100% !important;
`;

const Index = ({ t, location, get_wallet, content }) => {
  const [auth, setAuth] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCollapsedMobile, setIsCollapsedMobile] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    socket.on(C.ONLINE, (status) => onlineUser(decode(status)));

    Event.on("showAuthModal", () => {
      sendNotfication(
        "Please Login or Register !",
        "success",
        "bottom-left",
        true
      );
    });

    Event.on("logout", () => {
      setAuth(false);
    });

    Event.on("login", () => {
      setAuth(true);
    });

    const sessionCookie = Cookies.get("session");
    if (sessionCookie) {
      socket.emit(
        C.ONLINE,
        encode({
          jwt_token: storage.getKey("jwt_token"),
          user_token: storage.getKey("user_token"),
          security_key: storage.getKey("security_key"),
          secret_user: storage.getKey("secret_user"),
          secret_realtime: storage.getKey("secret_realtime"),
          client_system: storage.getKey("client_system"),
          token_key: storage.getKey("token_key"),
          secret_token: storage.getKey("secret_token"),
        })
      );
    }

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onlineUser = (data) => {
    wait(500).then(() => {
      if (data.status === true) {
        storage.setKey("logged", true);
        Cookies.set("uid", data.id, { expires: 14, path: '/' });
        Cookies.set("auth", true, { expires: 14, path: '/' });
        storage.setKey("name", data.name);
        storage.setKey("email", data.email);
        storage.setKey("credit", data.credit);
        storage.setKey("avatar", data.avatar);
        storage.setKey("friends", data.friends);
        storage.setKey("room", data.room);
        setAuth(true);
      } else {
        wait(1000).then(() => {
          localStorage.clear();
          setAuth(false);
        });
      }
    });
  };

  let wallet;
  try {
    wallet = get_wallet.show;
  } catch (e) {}

  return (
    <>
      <AppContainer>
        <Sidebar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          isCollapsedMobile={isCollapsedMobile}
          setIsCollapsedMobile={setIsCollapsedMobile}
          isSmallScreen={isSmallScreen}
        />
        <MainArea isSmallScreen={isSmallScreen} isCollapsed={isCollapsed}>
          <HeaderMainConatiner
            isSmallScreen={isSmallScreen}
            isCollapsed={isCollapsed}
          >
            <Header 
               isCollapsedMobile={isCollapsedMobile}
               setIsCollapsedMobile={setIsCollapsedMobile}
               isAuthed={storage.getKey("logged") || auth}
            />
          </HeaderMainConatiner>
          <ContentContainer
            isSmallScreen={isSmallScreen}
            isCollapsed={isCollapsed}
          >
            {wallet && <WalletAlert t={t} uid={get_wallet?.uid} />}
            {content}
          </ContentContainer>
          <Footer />
        </MainArea>
      </AppContainer>
    </>
  );
};

Index.propTypes = {
  get_wallet: PropTypes.any,
};

const mapStateToProps = (state) => ({
  get_wallet: state.items.get_wallet,
});

export default connect(mapStateToProps, null)(Index);
